module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex mt-3 align-items-end"
  }, [_c('h3', {
    staticClass: "mr-1"
  }, [_vm._v("Min/Max Settings")]), _vm._v(" "), (_vm.selectedPrincingType) ? _c('span', {
    staticClass: "fs-small dark bold ml-2"
  }, [_vm._v("Only available in prices per person")]) : _vm._e()]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "change": function($event) {
        return _vm.eventActivateUpdateFlag('minMaxRules')
      }
    }
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "form-getSelectedEvent row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "py-2 ml-2"
  }, [_c('label', {
    class: {
      'color-6': _vm.validations.getSelectedEvent.rulesBook.$invalid
    }
  }, [_vm._v("Participants (PAX) rules\n                                "), (_vm.validations.getSelectedEvent.rulesBook.$invalid) ? _c('span', {
    staticClass: "color-6 fs-smaller ml-2"
  }, [_vm._v("Maximum value must be greater than minimum value")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-3 mb-1"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mr-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minimumPaxPerBooking),
      expression: "minimumPaxPerBooking"
    }],
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.selectedPrincingType
    },
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.selectedPrincingType
    },
    domProps: {
      "value": (_vm.minimumPaxPerBooking)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.minimumPaxPerBooking = $event.target.value
      }, _vm.minBookingUpdate]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "w-100 ml-2"
  }, [_vm._v("Minimun")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maximumPaxPerBooking),
      expression: "maximumPaxPerBooking"
    }],
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.selectedPrincingType
    },
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.selectedPrincingType
    },
    domProps: {
      "value": (_vm.maximumPaxPerBooking)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.maximumPaxPerBooking = $event.target.value
      }, _vm.maxBookingUpdate]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "w-100 ml-2"
  }, [_vm._v("Maximum")])])])]), _vm._v(" "), _c('div', {
    staticClass: "py-1 ml-2 radios"
  }, [(_vm.getSelectedEvent.minimumPaxPerBooking > 0 || _vm.getSelectedEvent.maximumPaxPerBooking > 0) ? _c('div', [_c('span', {
    staticClass: "fs-small"
  }, [_vm._v("If the participants' rules are not fulfilled:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between mt-2",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('radio', {
    attrs: {
      "value": true,
      "disabled": _vm.selectedPrincingType
    },
    on: {
      "input": function($event) {
        return _vm.eventActivateUpdateFlag('minMaxRules')
      }
    },
    model: {
      value: (_vm.getSelectedEvent.rejectBookingBasedOnMinMax),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "rejectBookingBasedOnMinMax", $$v)
      },
      expression: "getSelectedEvent.rejectBookingBasedOnMinMax"
    }
  }, [_vm._v("\n                                        Block bookings\n                                    ")]), _vm._v(" "), _c('radio', {
    attrs: {
      "value": false,
      "disabled": _vm.selectedPrincingType
    },
    on: {
      "input": function($event) {
        return _vm.eventActivateUpdateFlag('minMaxRules')
      }
    },
    model: {
      value: (_vm.getSelectedEvent.rejectBookingBasedOnMinMax),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "rejectBookingBasedOnMinMax", $$v)
      },
      expression: "getSelectedEvent.rejectBookingBasedOnMinMax"
    }
  }, [_vm._v("\n                                        Pending to confirm\n                                    ")])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "py-2 ml-2"
  }, [_c('label', {
    class: {
      'color-6': _vm.validations.getSelectedEvent.rulesEvent.$invalid
    }
  }, [_vm._v("Participants (PAX) rules\n                                "), (_vm.validations.getSelectedEvent.rulesEvent.$invalid) ? _c('span', {
    staticClass: "color-6 fs-smaller ml-2"
  }, [_vm._v("Value must be between minimum and maximum")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minimumLotation),
      expression: "minimumLotation"
    }],
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.selectedPrincingType
    },
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.selectedPrincingType
    },
    domProps: {
      "value": (_vm.minimumLotation)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.minimumLotation = $event.target.value
      }, _vm.lotationEventUpdate]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "w-100 ml-2"
  }, [_vm._v("Minimun")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-2"
  }, [_c('span', {
    staticClass: "font-weight-600 pl-2"
  }, [_vm._v("Booking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-2"
  }, [_c('span', {
    staticClass: "font-weight-600 pl-2"
  }, [_vm._v("Event")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-2"
  }, [_c('span', {
    staticClass: "fs-small"
  }, [_vm._v("If a minimum PAX per event is set, bookings are pending until this minimum is reached ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ad6c5ade", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad6c5ade"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaRulesPax.vue
// module id = 1435
// module chunks = 0